import React from 'react';
import {Modal} from './index';

export const ImageModal = ({file, setFile}) => (
  <div className="relative w-full">
    <Modal
      show={Boolean(file)}
      onClose={() => setFile('')}
      extraModalClasses="max-w-[728px] z-10  h-fit max-h-[95%] sm:max-h-full  absolute bottom-0 sm:relative"
      extraModalClassesStart="flex items-center justify-center"
      noHidden
    >
      <img
        src={file}
        alt={file?.name || 'image'}
        className="h-full w-auto object-cover object-center"
      />
      <div
        onClick={() => setFile('')}
        className="flex cursor-pointer items-center justify-center absolute -top-10 -right-10 rounded-full z-50 bg-white h-8 w-8"
      >
        <div className="w-5 h-5 border rounded-full flex items-center justify-center">
          <span className="text-xs">x</span>
        </div>
      </div>
    </Modal>
  </div>
);
